import { onView, onMount, onDestroy } from "@/modules/_";
import gsap, { SplitText } from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const splitTextLines = element.querySelectorAll(".line");

  const hasDelay = element.closest(".header_wrap");

  gsap.set(splitTextLines, {
    yPercent: 102,
  });

  const observer = onView(element, {
    root: null,
    rootMargin: "0px",
    threshold: 0.4,
    autoStart: false,
    once: true,
    callback: ({ isIn }) => {
      if (isIn) {
        gsap.to(splitTextLines, {
          yPercent: 0,
          duration: 0.6,
          ease: "power2.out",
          stagger: 0.1,
          delay: hasDelay ? 0.2 : 0,
        });
      }
    },
  });

  onMount(() => {
    observer.start();
  });

  onDestroy(() => {
    observer.destroy();
  });
}
